export const indexBannerSliderOptions = (instance, options) => {
    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            hideOnClick: false,
            dynamicBullets: false,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
    }
}